import { LevelOfEducation, Subject } from '~/types/booking'

export default function generateSubjectsObject(
  subjects: Subject[],
  levelsOfEducation: LevelOfEducation[],
): {
  subjects: Array<{ name: Subject }>
  levelsOfEducation: LevelOfEducation[]
} {
  return {
    subjects: subjects.map((elem) => ({ name: elem })),
    levelsOfEducation,
  }
}
